// extracted by mini-css-extract-plugin
export default {"message":"Message_message__kLrV2","title":"Message_title__20GMO","text":"Message_text__B8mok"};